import React from 'react'
import Applicant from '../Components/Applicant'
import Head from '../Components/Head'


import Test from '../Components/Test'

const HomePage = () => {
  return (
    <div>
         <Test/>
        <Head/>
        {/* <Applicant/> */}
        
    </div>
  )
}

export default HomePage
